import React from 'react';
import AdminLayout from '../AdminLayout';
import './PlaceholderPage.css';

interface Props {
  title: string;
  path: string;
}

const PlaceholderPage = ({ title, path }: Props) => {
  return (
    <AdminLayout title={`Admin Panel - ${title}`} currentPath={path}>
      <div className="placeholder-page">
        <div className="placeholder-content">
          <h1>{title}</h1>
          <p>This page is coming soon.</p>
        </div>
      </div>
    </AdminLayout>
  );
};

export default PlaceholderPage;